import React from 'react'
import { router } from '@inertiajs/react'
import Layout from '../Layout'
import DataTable from '../../../Components/DataTable'
import Button from '../../../Components/Button'
import ResourceIndexHeader from '../../../Components/ResourceIndexHeader'
import { useDeleteWithConfirmation } from '../../../hooks/useDeleteWithConfirmation'
import { formatPrice } from '../../../utils/formatters'

export default function Index({
  account,
  accounts,
  navigation,
  packages,
  is_admin
}) {
  const handleDelete = useDeleteWithConfirmation('/manage/packages')

  const columns = [
    {
      key: 'name',
      label: 'Name',
      sortable: true,
      render: (value, item) => (
        <div className="flex items-center">
          {item.image_url && (
            <img
              src={item.image_url}
              alt={item.name}
              className="h-10 w-10 rounded-lg object-cover mr-3"
            />
          )}
          <div>
            <div className="font-medium text-gray-900">{value}</div>
            {item.description && (
              <div className="text-gray-500 truncate max-w-xs">{item.description}</div>
            )}
          </div>
        </div>
      )
    },
    {
      key: 'base_price_pence',
      label: 'Price (pp)',
      sortable: true,
      className: 'font-medium text-gray-900',
      render: (value) => formatPrice(value)
    },
    {
      key: 'min_guests',
      label: 'Guests',
      render: (value, item) => `${value || 1}–${item.max_guests || '∞'}`
    },
    {
      key: 'active',
      label: 'Status',
      render: (value) => (
        <span className={`inline-flex rounded-full px-2 py-1 text-xs font-semibold ${
          value ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'
        }`}>
          {value ? 'Active' : 'Inactive'}
        </span>
      )
    },
    {
      key: 'add_on_count',
      label: 'Add-ons',
      className: 'text-gray-500'
    }
  ]

  return (
    <Layout
      account={account}
      accounts={accounts}
      navigation={navigation}
      title="Packages"
      is_admin={is_admin}
    >
      <ResourceIndexHeader
        count={packages.length}
        singular="package"
        plural="packages"
        addHref="/manage/packages/new"
        addLabel="Add Package"
      />

      <DataTable
        data={packages}
        columns={columns}
        actions={(item) => (
          <>
            <Button link href={`/manage/packages/${item.id}/edit`}>Edit</Button>
            <Button link variant="danger" onClick={() => handleDelete(item)}>Delete</Button>
          </>
        )}
        searchable={true}
        searchPlaceholder="Search packages..."
        emptyState={{
          message: 'No packages found',
          action: { label: 'Add your first package', href: '/manage/packages/new' }
        }}
        baseUrl="/manage/packages"
      />
    </Layout>
  )
}
